import React from 'react';
import { Radio as AntdRadio, RadioProps } from 'antd';
import styled from '@emotion/styled';

const StyledRadio = styled(AntdRadio)``;
const Radio = (props: RadioProps) => {
  return <StyledRadio {...props}></StyledRadio>;
};
Radio.Button = AntdRadio.Button;
Radio.Group = AntdRadio.Group;

export default Radio;
